module.exports = __webpack_public_path__ + "static/therooftop_02-7e8abfc49c30c5e0820696f1b1fc620b.webp";